export const MARKERS_COLORS = {
  vendita: "#BB005F",
  affitto: "#88a650",
  privati: "#274E9D",
};

export const Logo = `${window.location.origin}/wp-content/uploads/2021/10/HomePrime-logo.png`;
export const imagePlaceholder = `${window.location.origin}/wp-content/themes/mb-child/images/placeholder-image.png`;

export const filtersFormSelects = [
  {
    label: "Contratto",
    key: "contract",
    options: [
      { value: "vendita", label: "Vendita" },
      { value: "affitto", label: "Affitto" },
    ],
  },
];
